/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
import _join from 'lodash/join';
import _merge from 'lodash/merge';
import { create } from 'mobx-persist';

var BasesOptions =
/** @class */
function () {
  function BasesOptions() {}
  /**
  * 重置默认配置 lodash.merge() 方式
  * @param config
  */


  BasesOptions.resetConfig = function (config) {
    return _merge(BasesOptions, config);
  };
  /**
   * 状态 响应 初始化配置
   * mobx 6 的makeObservable
   * vue 3 reactive
   * @param target
   * @param annotations
   * @param options
   */
  // static reactive<T extends object, AdditionalKeys extends PropertyKey = never>(target, annotations?: AnnotationsMap<T, NoInfer<AdditionalKeys>>, options?: CreateObservableOptions) {


  BasesOptions.reactive = function (target) {// mobx 6 的makeObservable
    // makeObservable && makeObservable(target, annotations, options)
  };
  /**
   * localStorage Hydrate 使用
   * 小程序 需要 重新配置
   * @returns
   */


  BasesOptions.createStorage = function () {
    return localStorage;
  };
  /**
   * 创建 Storage key
   * @param key
   */


  BasesOptions.createStorageKey = function (key) {
    return _join([this.storagePrefix, key], '_');
  };
  /**
   * 持久化 mobx-persist
   * @static
   * @memberof basesOptions
   */


  BasesOptions.createHydrate = function () {
    return create({
      storage: BasesOptions.createStorage(),
      jsonify: BasesOptions.jsonify,
      debounce: BasesOptions.debounce
    });
  };
  /** 调试日志 */

  BasesOptions.debug = true; //process.env.NODE_ENV === 'development';

  /** 持久化存储前缀 */

  BasesOptions.storagePrefix = '_APP';
  /** 持久化序列化 */

  BasesOptions.jsonify = true;
  /** 持久化存储 延迟 */

  BasesOptions.debounce = 0;
  /** 数据唯一 Key [标识] */

  BasesOptions.dataKey = 'key';
  /** 请求 pagination */

  BasesOptions.pagination = {
    method: 'get'
  };
  /** 请求 details */

  BasesOptions.details = {
    method: 'get',
    url: '/{key}',
    loading: true
  };
  /** 请求 insert */

  BasesOptions.insert = {
    method: 'post'
  };
  /** 请求 update */

  BasesOptions.update = {
    method: 'put',
    url: '/{key}'
  };
  /** 请求 delete */

  BasesOptions["delete"] = {
    method: 'delete'
  };
  /** 请求 export */

  BasesOptions["export"] = {
    method: 'get',
    responseType: 'blob',
    loading: true
  };
  /** 列表 无限滚动 瀑布流模式 */

  BasesOptions.infinite = false;
  /** baseModel get value toJs */

  BasesOptions.observableToJS = false;
  /** 远程数据开关 添加 修改 删除 等操作后 走API */

  BasesOptions.remoteRefresh = false;
  /** 分页参数配置 */

  BasesOptions.paginationParams = {
    currentKey: 'current',
    pageSizeKey: 'pageSize',
    filterKey: undefined,
    sortKey: undefined,
    defaultCurrent: 1,
    defaultPageSize: 20,
    infiniteKey: 'lastKey',
    // lastKey: 'lastKey',
    response: {
      current: 'current',
      pageSize: 'pageSize',
      total: 'total',
      dataSource: 'dataSource'
    }
  };
  return BasesOptions;
}();
var EnumBasesKeys;

(function (EnumBasesKeys) {
  /** 请求 */
  EnumBasesKeys["request"] = "request";
  /** 响应 */

  EnumBasesKeys["response"] = "response";
  /** 当前请求的 生成时间戳 */

  EnumBasesKeys["timestamp"] = "timestamp";
  /** 是否已加载完成，加载完成后不再触发 */

  EnumBasesKeys["finished"] = "finished";
  /** 请求出错 */

  EnumBasesKeys["requestError"] = "requestError";
  /** 选择行数据 */

  EnumBasesKeys["selectedRow"] = "selectedRow";
})(EnumBasesKeys || (EnumBasesKeys = {}));

var EnumActionKeys;

(function (EnumActionKeys) {
  EnumActionKeys["pagination"] = "pagination";
  EnumActionKeys["details"] = "details";
  EnumActionKeys["insert"] = "insert";
  EnumActionKeys["update"] = "update";
  EnumActionKeys["delete"] = "delete";
  EnumActionKeys["export"] = "export";
})(EnumActionKeys || (EnumActionKeys = {}));

export { BasesOptions, EnumActionKeys, EnumBasesKeys };
//# sourceMappingURL=basesOptions.js.map
